import Resource from './common/resource';

class SnippetsFolders extends Resource {
  path = 'snippets/folders';
}

export default SnippetsFolders;
